import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-ext";
import axios from "axios";
var youtubeRegex = /^.*(?:youtu.be\/|v\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/;
var vimeoRegex = /(?:http|https)?:\/\/(?:www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;
var OptionListInput = /** @class */ (function (_super) {
    tslib_1.__extends(OptionListInput, _super);
    function OptionListInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itemsPerRow = null;
        _this.warningsVisible = false;
        _this.warningTimer = null;
        return _this;
    }
    OptionListInput.prototype.mounted = function () {
        window.addEventListener("resize", this.ensureItemsPerRow);
        this.ensureItemsPerRow();
    };
    OptionListInput.prototype.openPopup = function (option) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var media;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEmbedMedia(option)];
                    case 1:
                        media = _a.sent();
                        this.$ui.openEmbedPopup(media);
                        return [2 /*return*/];
                }
            });
        });
    };
    OptionListInput.prototype.getEmbedMedia = function (option) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, mediaCollection, _b, _c, mediaUrl, youtubeEmbed, vimeoEmbed, data, e_1_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        mediaCollection = [];
                        if (!this.enableZoom) return [3 /*break*/, 9];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 7, 8, 9]);
                        _b = tslib_1.__values(option.embedMedia), _c = _b.next();
                        _d.label = 2;
                    case 2:
                        if (!!_c.done) return [3 /*break*/, 6];
                        mediaUrl = _c.value;
                        youtubeEmbed = mediaUrl.match(youtubeRegex);
                        if (youtubeEmbed) {
                            mediaCollection.push({
                                previewImage: "https://i.ytimg.com/vi/" + youtubeEmbed[1] + "/hq720.jpg",
                                embedCode: '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + youtubeEmbed[1] + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
                            });
                            return [3 /*break*/, 5];
                        }
                        vimeoEmbed = mediaUrl.match(vimeoRegex);
                        if (!vimeoEmbed) return [3 /*break*/, 4];
                        return [4 /*yield*/, axios.get("https://vimeo.com/api/oembed.json?url=" + mediaUrl)];
                    case 3:
                        data = (_d.sent()).data;
                        mediaCollection.push({
                            previewImage: data && data.thumbnail_url ? data.thumbnail_url : null,
                            embedCode: '<div style="height: 100%;position:relative;" class="vimeo">' + data.html + '</div>'
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        mediaCollection.push({
                            previewImage: mediaUrl,
                            embedCode: null
                        });
                        _d.label = 5;
                    case 5:
                        _c = _b.next();
                        return [3 /*break*/, 2];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_1_1 = _d.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/, mediaCollection];
                }
            });
        });
    };
    OptionListInput.prototype.ensureItemsPerRow = function () {
        var e_2, _a;
        var container = this.$refs.listGroup;
        var previousTop = 0;
        if (!container || !container.children)
            return;
        var index = 1;
        try {
            for (var _b = tslib_1.__values(Array.from(container.children)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                var boundingRect = child.getBoundingClientRect();
                if (previousTop != 0 && previousTop != boundingRect.top) {
                    break;
                }
                previousTop = boundingRect.top;
                this.itemsPerRow = index;
                index++;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    OptionListInput.prototype.getCssClasses = function (option, index) {
        var classes = [];
        if (option.disabled)
            classes.push("disabled");
        if (this.isActive(option))
            classes.push("active");
        if (this.enableZoom)
            classes.push("with-preview");
        if (index % this.itemsPerRow == 0 || index == this.optionList.options.length)
            classes.push("row-last");
        if ((index - 1) % this.itemsPerRow == 0)
            classes.push("row-first");
        if (this.itemClasses)
            classes = tslib_1.__spread(classes, this.itemClasses);
        return classes;
    };
    OptionListInput.prototype.isActive = function (option) {
        if (!this.value)
            return false;
        return this.multiple
            ? this.value.indexOf(option.value.toString()) >= 0
            : this.value == option.value;
    };
    OptionListInput.prototype.setValue = function (option) {
        if (option.disabled)
            return;
        this.$state.dirty = true;
        if (this.multiple) {
            var values = this.value || [];
            var index = values.indexOf(option.value.toString());
            if (index !== -1) {
                values.splice(index, 1);
            }
            else {
                values.push(option.value.toString());
                this.showWarning(option);
            }
            this.$emit("input", values);
        }
        else {
            this.$emit("input", option.value);
            this.showWarning(option);
        }
    };
    OptionListInput.prototype.showWarning = function (option) {
        clearTimeout(this.warningTimer);
        this.warningsVisible = option.warnings.length > 0 && this.withImages;
        if (this.warningsVisible) {
            var self_1 = this;
            this.warningTimer = setTimeout(function () {
                self_1.warningsVisible = false;
            }, 4000);
        }
    };
    tslib_1.__decorate([
        Prop(),
        tslib_1.__metadata("design:type", Object)
    ], OptionListInput.prototype, "optionList", void 0);
    tslib_1.__decorate([
        Prop({ type: [String, Array] }),
        tslib_1.__metadata("design:type", Object)
    ], OptionListInput.prototype, "value", void 0);
    tslib_1.__decorate([
        Prop({ type: Boolean }),
        tslib_1.__metadata("design:type", Boolean)
    ], OptionListInput.prototype, "multiple", void 0);
    tslib_1.__decorate([
        Prop({ type: Boolean }),
        tslib_1.__metadata("design:type", Boolean)
    ], OptionListInput.prototype, "withImages", void 0);
    tslib_1.__decorate([
        Prop({ type: String }),
        tslib_1.__metadata("design:type", String)
    ], OptionListInput.prototype, "linkText", void 0);
    tslib_1.__decorate([
        Prop({ type: String }),
        tslib_1.__metadata("design:type", String)
    ], OptionListInput.prototype, "classes", void 0);
    tslib_1.__decorate([
        Prop({ type: Boolean }),
        tslib_1.__metadata("design:type", String)
    ], OptionListInput.prototype, "enableZoom", void 0);
    tslib_1.__decorate([
        Prop({ type: Array }),
        tslib_1.__metadata("design:type", Array)
    ], OptionListInput.prototype, "itemClasses", void 0);
    OptionListInput = tslib_1.__decorate([
        Component
    ], OptionListInput);
    return OptionListInput;
}(Vue));
export default OptionListInput;
